//设置商品列表
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
//通过三级类目获取商品列表
export const GET_LIST_BY_CATEGORY = "GET_LIST_BY_CATEGORY";
//通过品牌ID和二级类目ID获取商品列表
export const GET_LIST_BY_BRAND = "GET_LIST_BY_BRAND";
//获取商品列表
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";

export const SET_NO_MORE = "SET_NO_MORE";
export const SET_KEYWORD = "SET_KEYWORD";
export const SET_SEARCH_SOURCE = "SET_SEARCH_SOURCE";
//搜索商品类型
export const SET_SEARCH_TYPE = "SET_SEARCH_TYPE";

export const SET_PAGE = "SET_PAGE";

export const SET_PAGE_SIZE = "SET_PAGE_SIZE";

export const SET_IS_REQUEST_SUCCESS = "SET_IS_REQUEST_SUCCESS";
//加车晃动
export const SET_IS_WOBBLE = "SET_IS_WOBBLE";
//纠错后的关键字
export const SET_OLD_KEYWORD = "SET_OLD_KEYWORD";
//纠错后的关键字
export const SET_RE_CORRECT = "SET_RE_CORRECT";
//总页数
export const SET_PAGE_COUNT = "SET_PAGE_COUNT";


// WEBPACK FOOTER //
// ./src/store/search-bar/type.js